import http from "./http.js";

export const antiepidemic = {
    add(params) {
        return http.postRequestToken("/uc/reg/preventionInfo/add", params)
    },
    update(params) {
        return http.postRequestToken("/uc/reg/preventionInfo/update", params)
    },
    getDetail() {
        return http.postRequestToken("/uc/reg/preventionInfo/user/detail", {})
    }
}